// extracted by mini-css-extract-plugin
module.exports = {"controls":"CineControls-styles-module--controls--1SyJN"};